<script setup>
import { ref } from "vue";
import { getRequest } from "@/utils/request.js";

const title = ref("");
const open = ref(false);
const confirmLoading = ref(false);
const formModel = ref({});

const handleShow = (record) => {
  formModel.value = Object.assign({}, { ...record });
  open.value = true;
  loadData();
};

const loadData = () => {
  getRequest(`/company/${formModel.value.id}`).then((res) => {
    if (res.success) {
      formModel.value = Object.assign({}, { ...res.data });
    }
  });
};

const handleClose = () => {
  open.value = false;
  formModel.value = Object.assign({});
};

defineExpose({
  handleShow,
  title,
});
</script>

<template>
  <a-modal
    width="1200px"
    :open="open"
    :title="title"
    :confirm-loading="confirmLoading"
    @cancel="handleClose"
  >
    <a-descriptions
      style="padding-top: 10px"
      title="基本信息"
      bordered
      size="small"
      :labelStyle="{
        width: 'fit-content',
        wordBreak: 'keep-all',
      }"
    >
      <a-descriptions-item label="企业/个人名称">
        {{ formModel.name }}
      </a-descriptions-item>
      <a-descriptions-item label="类型">
        <a-tag v-if="formModel.type === 'COMPANY'" color="green"> 企业</a-tag>
        <a-tag v-if="formModel.type === 'PERSON'" color="orange"> 个人</a-tag>
      </a-descriptions-item>
      <a-descriptions-item label="统一社会信用代码/身份证号">
        {{ formModel.code }}
      </a-descriptions-item>
      <a-descriptions-item label="认证信息" :span="3">
        {{ formModel.authenticationInfo }}
      </a-descriptions-item>
    </a-descriptions>
    <a-descriptions
      style="padding-top: 30px"
      title="工商信息"
      bordered
      size="small"
      :labelStyle="{
        width: 'fit-content',
        wordBreak: 'keep-all',
      }"
    >
      <a-descriptions-item label="融资规模">
        {{ formModel.financingStage }}
      </a-descriptions-item>
      <a-descriptions-item label="员工规模">
        {{ formModel.staffSize }}
      </a-descriptions-item>
      <a-descriptions-item label="注册资本">
        {{ formModel.registeredCapital }}
      </a-descriptions-item>
      <a-descriptions-item label="工作时间">
        {{ formModel.workingTime }}
      </a-descriptions-item>
      <a-descriptions-item label="福利待遇">
        {{ formModel.benefits }}
      </a-descriptions-item>
      <a-descriptions-item label="人才发展">
        {{ formModel.talentDevelopment }}
      </a-descriptions-item>
      <a-descriptions-item label="公司介绍" :span="3">
        {{ formModel.description }}
      </a-descriptions-item>
      <a-descriptions-item label="公司地址" :span="3">
        {{ formModel.address }}
      </a-descriptions-item>
    </a-descriptions>
    <a-descriptions
      v-if="formModel.photoList?.length"
      style="padding-top: 30px"
      title="公司相册"
      size="small"
    >
    </a-descriptions>
    <div v-if="formModel.photoList?.length">
      <a-image-preview-group>
        <a-image
          v-for="photo in formModel.photoList"
          :key="photo.id"
          :width="200"
          :src="$imageUrl(photo.url)"
        />
      </a-image-preview-group>
    </div>
    <a-descriptions
      v-if="formModel.productList?.length"
      style="padding-top: 30px"
      bordered
      title="公司产品"
      size="small"
      :labelStyle="{
        width: 'fit-content',
        wordBreak: 'keep-all',
      }"
    >
      <template v-for="product in formModel.productList" :key="product.id">
        <a-descriptions-item label="产品名称">
          {{ product.name }}
        </a-descriptions-item>
        <a-descriptions-item label="产品logo">
          <a-avatar :size="80" :src="$imageUrl(product.logo)" />
        </a-descriptions-item>
        <a-descriptions-item label="产品介绍">
          {{ product.description }}
        </a-descriptions-item>
      </template>
    </a-descriptions>
  </a-modal>
</template>

<style scoped lang="scss"></style>
